import type { AnalyticsClient, AnalyticsProperties } from "./analytics-client";
import { type PostHogSdk, whenReady } from "./posthog-sdk";

/** Adapts the shared SDK to {@link AnalyticsClient}. */
export function createPostHogAnalytics(sdk: PostHogSdk): AnalyticsClient {
  // Nothing reports until the session has been restored, so the first call is
  // soon enough to start the SDK.
  return {
    capture(event: string, properties?: AnalyticsProperties) {
      whenReady(sdk, (posthog) => {
        posthog.capture(event, properties);
      });
    },
    identify(distinctId: string, properties?: AnalyticsProperties) {
      whenReady(sdk, (posthog) => {
        posthog.identify(distinctId, properties);
      });
    },
    register(properties: AnalyticsProperties) {
      whenReady(sdk, (posthog) => {
        posthog.register(properties);
      });
    },
    reset() {
      whenReady(sdk, (posthog) => {
        posthog.reset();
      });
    },
    captureException(error: Error, properties?: AnalyticsProperties) {
      whenReady(sdk, (posthog) => {
        posthog.captureException(error, properties);
      });
    },
  };
}
